import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

const IconConfirmCheck = ({
  className,
  size,
}) => {
  const id = useMemo(() => (
    uuidv4()
  ), []);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        width="80"
        height="80"
        rx="28"
        fill={`url(#${id})`}
      />
      <path
        d="M36.5 46.7903L54.884 28.4043L57.714 31.2323L36.5 52.4463L23.772 39.7183L26.6 36.8903L36.5 46.7903Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={id}
          x1="11.9708"
          y1="0.566317"
          x2="75.3515"
          y2="85.5954"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            stopColor="#25A2FA"
          />
          <stop
            offset="0.483812"
            stopColor="#0075FF"
          />
          <stop
            offset="1"
            stopColor="#3F58EA"
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

IconConfirmCheck.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
};

IconConfirmCheck.defaultProps = {
  className: null,
  size: 80,
};

export default memo(IconConfirmCheck);
